import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IQuotation } from "mobx-stores/_models/quotation/quotation";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import {
  DetailIconButton,
  ExpandButton,
} from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const QuotationTable = observer(() => {
  const {
    quotationManagement: {
      quotations,
      getQuotations,
      pagination,
      searchConditionAsNaturalLanguage,
    },
  } = useStores();

  useEffect(() => {
    getQuotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getQuotations();
    },
    [getQuotations, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>STT</TableCell>
          <TableCell>Ngày</TableCell>
          <TableCell>Số Phiếu</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {quotations.map((x, i) => (
          <Row data-id={x.id} key={x.id} quotation={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  quotation: IQuotation;
};
const Row = observer(({ quotation }: RowProps) => {
  const {
    quotationManagement: { setProp },
  } = useStores();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const goDetailHandler = useCallback(
    (order: IQuotation) => {
      navigate(`${order.id}`);
      setProp("quotationDetail", cloneDeep(order));
    },
    [navigate, setProp],
  );
  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{quotation.orderNumber || ""}</TableCell>
        <TableCell>{dateTimeDisplay(quotation.date || "")}</TableCell>
        <TableCell>{quotation.number}</TableCell>
        <TableCell>
          {quotation.customer ? (
            <CustomerDealingAndActiveInfo
              customer={quotation.customer}
            ></CustomerDealingAndActiveInfo>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell>{quotation.note}</TableCell>
        <TableCell width={"20px"}>
          <DetailIconButton
            onClick={() => goDetailHandler(quotation)}
          ></DetailIconButton>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={7} headerTitle="Chi tiết mặt hàng">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tên hàng</TableCell>
                  <TableCell>Mã hàng</TableCell>
                  <TableCell>Mã vạch</TableCell>
                  <TableCell>ĐVT</TableCell>
                  <TableCell>SL Đặt</TableCell>
                  <TableCell>Đơn giá</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quotation.items.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {item.product ? (
                        <ProductNameAndActiveInfo
                          product={item.product}
                        ></ProductNameAndActiveInfo>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell>{item.product?.code || ""}</TableCell>
                    <TableCell>{item.product?.barcode || ""}</TableCell>
                    <TableCell>
                      {item.product?.unitOfCalculation || ""}
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.amount}></NumberText>
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.unitPrice}></NumberText>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
